import { User } from "prisma/cm/client";

export function getWeightedCompValue<T extends Pick<User, "weightedCompValues">>(
  user: T,
  weightedCompId: string,
) {
  return user.weightedCompValues[weightedCompId];
}
